<template>
    <b-list-group class="list-group-flush">
        <b-list-group-item v-for="(payment, index) in this.payments " v-bind:key="`payment-${index}`">
            <div class="d-flex align-items-center">
                <div class="small">
                    <i class="fi" :class="payment.success ? 'text-success flaticon-tick' : 'test-danger flaticon-danger'"></i>
                </div>
                <div class="small ml-2">{{payment.created_at | date}}</div>
                <div class="small ml-2">{{payment.token}}</div>
                <div class="ml-auto text-center">
                    <b-badge class="mx-2 text-uppercase" style="width: 80px"
                             v-if="payment.status"
                             :variant="statusVariant(payment.status).variant">
                        {{statusVariant(payment.status).label}}
                    </b-badge>
                    {{payment.amount | currency}}
                </div>
            </div>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
import Const from "../../../const";

export default {
    name: "AdminRequestsPayments",
    components: {},
    props: {
        payments: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            paymentStatuses: Const.PAYMENT_STATUSES
        }
    },
    computed: {},
    mounted() {

    },
    methods: {
        statusVariant: function (status) {
            return Const.PAYMENT_STATUSES.hasOwnProperty(status)
                ? Const.PAYMENT_STATUSES[status]
                : {
                    variant: 'secondary',
                    label: 'status',
                }
        }
    }
}
</script>

<style scoped>

</style>
